import * as urlUtils from 'utils/Url';


export function getPathReperksOverview(qs={}) {
  return urlUtils.appendQueryString(`/reperks-overview`, qs);
}

export function getPathReperksConnections(qs={}) {
  return urlUtils.appendQueryString(`/reperks-connections`, qs);
}

export function getPathReperksLoyaltySetup(qs={}) {
  return urlUtils.appendQueryString(`/reperks-loyalty-setup`, qs);
}

export function getPathReperksAnalytics(qs={}) {
  return urlUtils.appendQueryString(`/reperks-analytics`, qs);
}

export function getPathEditReperksSettings() {
  return `/reperks-settings/edit`;
}

export function getPathEditReperksWidget() {
  return `/reperks-widget/edit`;
}

export function getPathReperksRewards(qs={}) {
  return urlUtils.appendQueryString(`/reperks-rewards`, qs);
}

export function getPathAddReperksReward() {
  return `/reperks-rewards/add`;
}

export function getPathEditReperksReward(rewardId) {
  return `/reperks-rewards/${rewardId}/edit`;
}

export function getPathReplicateReperksReward(rewardId) {
  return `/reperks-rewards/${rewardId}/replicate`;
}

export function getPathReperksRewardCoupons(rewardId, qs={}) {
  return urlUtils.appendQueryString(`/reperks-rewards/${rewardId}/coupons`, qs);
}


export function getPathReperksEarningPoints(qs={}) {
  return urlUtils.appendQueryString(`/reperks-earning-points`, qs);
}

export function getPathAddReperksActivityRule() {
  return `/reperks-activity-rules/add`;
}

export function getPathEditReperksActivityRule(ruleId) {
  return `/reperks-activity-rules/${ruleId}/edit`;
}

export function getPathReplicateReperksActivityRule(ruleId) {
  return `/reperks-activity-rules/${ruleId}/replicate`;
}

export function getPathReperksActivities(qs={}) {
  return urlUtils.appendQueryString(`/reperks-activities`, qs);
}

export function getPathReperksMembers(qs={}) {
  return urlUtils.appendQueryString(`/reperks-members`, qs);
}

export function getPathReperksMemberProfile(memberId, qs={}) {
  return urlUtils.appendQueryString(`/reperks-members/${memberId}/profile`, qs);
}

export function getPathReperksEmails(qs={}) {
  return urlUtils.appendQueryString(`/reperks-emails`, qs);
}

export function getPathEditReperksEmails() {
  return `/reperks-emails/edit`;
}

export function getPathReperksEmailRecipients(emailId, qs={}) {
  return urlUtils.appendQueryString(`/reperks-emails/${emailId}/recipients`, qs);
}

export function getPathReperksEmailAnalytics(emailId, qs={}) {
  return urlUtils.appendQueryString(`/reperks-emails/${emailId}/analytics`, qs);
}

export function getPathReperksEmailConversions(emailId, qs={}) {
  return urlUtils.appendQueryString(`/reperks-emails/${emailId}/conversions`, qs);
}

